(function() {
  'use strict';

  angular
    .module('sempraWebapp')
    .controller('errorPageWithRedirectToDashboardController', errorPageWithRedirectToDashboardController);

  /** @ngInject */
  function errorPageWithRedirectToDashboardController($scope, ErrorPageViewModel, errorActions, applicationStore, $state) {
    var vm = this;

    vm.error = new ErrorPageViewModel();

    init ();

    function init () {
      // listen for message from dispatcher
      showErrorMsg(applicationStore.get().errorPageMsg);

      $scope.$on('$destroy', function () {
        vm.error.destroy();
      });
    }

    function showErrorMsg(errText){
      vm.error.errorMessage = errText;
    }

    vm.goBack = function(){
      errorActions.acknowledgeAndGoBack();
    };

    vm.goToDashboard = function(){
      $state.go('app.dashboardTechnology');
    };

  }
})();
